import { ReactNode } from 'react';
import { variables } from '..';
import { styled } from '@mui/material';

export function Error({ children }: ErrorProps) {
  return <Spa>{children}</Spa>;
}

interface ErrorProps {
  children: ReactNode;
}

const Spa = styled('span')(({ theme }) => ({ color: variables.brandDanger }));
